module.exports = __webpack_public_path__ + "static/media/greenRev_tablet.be1a72dd.png";